<!-- Events -->
<!-- itemCreated -->

<template>
  <v-container fluid>
    <v-row>
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="50"
        item-key="effective_start"
        height="550px"
        style="width:100%"
      >
        <template v-slot:item.updated_at="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
              >
              {{ formatEpoch(item.updated_at, 'YYYY-MM-DD HH:mm:ss') }}
              </span>
            </template>
            <p>
              {{ formatEpoch(item.updated_at, 'ddd MMM DD, yyyy HH:mm:ss') }}
            </p>
            <p>{{ formatEpochFromNow(item.updated_at) }}</p>
          </v-tooltip>
        </template>
        <template v-slot:item.updated_by="{ item }">
          {{ formateUserName(item.user_first_name, item.user_last_name) }}
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-if="item.user_is_staff"
                v-bind="attrs"
                color="success"
                v-on="on"
              >
                mdi-shield-account
              </v-icon>
            </template>
            Staff Member
          </v-tooltip>

        </template>
      </v-data-table>
    </v-row>
  </v-container>
</template>

<script>
  // Utilities
  import { mapActions, mapGetters } from 'vuex'
  import {
    ACCT_GET_ACCOUNT_ACTIVITY,
  } from '../../store/actions.types'
  import basicMixin from '../../mixins/basic'
  export default {
    name: 'AccountActivity',
    mixins: [basicMixin],

    inheritAttrs: false,

    props: {
    },
    data: function () {
      return {
        currentObject: {},
        snapshotObject: {},
        formMode: '',
        formErrors: [],
        overlayAbsolute: true,
        overlayDisplay: false,
        headers: [
          {
            text: 'Timestamp',
            align: 'start',
            sortable: true,
            value: 'updated_at',
          },
          {
            text: 'User',
            align: 'start',
            sortable: true,
            value: 'updated_by',
          },
          {
            text: 'Activity',
            align: 'start',
            sortable: false,
            value: 'display_text',
          },
        ],
      }
    },

    computed: {
      ...mapGetters({
        items: 'acctSelectedAccountActivity',
        selectedAccount: 'acctSelectedAccount',
      }),
    },
    async created () {
      this.init()
    },
    async mounted () {
      this.init()
    },
    methods: {
      ...mapActions({
        getActivity: ACCT_GET_ACCOUNT_ACTIVITY,
      }),
      init () {
        console.log(`Initializing ${name} setting values!`, this.item)
        this.getActivity()
        this.formMode = 'read'
        // console.log(val)
        // this.currentObject = { ...this.item }
        // this.snapshotObject = { ...this.item }
      },
      resetForm () {
        this.overlayDisplay = false
        this.currentObject = { ...this.snapshotObject }
        this.formErrors = []
      },
    },

  }
</script>

<style>
</style>
